import { Container } from "./style";

export function Header({ title, setModalFormsIsOpen }) {
    return(
        <Container>
            <span onClick={() => setModalFormsIsOpen(false)}>
                &#10006;
            </span>
            <h2>{title}</h2>
        </Container>
    )
}
